module.exports = __webpack_public_path__ + "static/media/costcase8.5fa61bad.png";